import { useWeb3React } from '@web3-react/core'
import Zksync from 'assets/png/Zksync.png'
import bera from 'assets/png/bera.png'
import bsc from 'assets/png/bsc.png'
import clsx from 'clsx'
import { useMemo } from 'react'
import { Helmet } from 'react-helmet-async/lib/index'
import { FormProvider, useForm } from 'react-hook-form'
import { ModalAa } from './aa'
import { Balance } from './balance'
import { Button } from './button'
import { Chain } from './chain'
import { BERA_OFT, BSC_OFT, ZKSYNC_OFT } from './constant'
import { EstimateReceive } from './estimate'
import { Header } from './header'
import { useFee } from './hook/useFeeBridge'

export interface BrigeForm {
  active: number
  value: string
  from: {
    chainId: number
    name: string
    img: string
  }
  to: {
    name: string
    chainId: number
    img: string
  }
}

export function Bridge() {
  const { data } = useFee()
  const { chainId } = useWeb3React()
  const { from, to } = useMemo(() => {
    // Allowed routes:
    // - zkSync → BSC
    // - zkSync → WLD
    // - Bera → zkSync
    // Block: zkSync → Bera, Bera → BSC, BSC → Bera, BSC → zkSync

    if (chainId === ZKSYNC_OFT.chainId) {
      // Default to zkSync → BSC when connected to zkSync
      return {
        from: {
          chainId: ZKSYNC_OFT.chainId,
          name: ZKSYNC_OFT.name,
          img: Zksync,
        },
        to: {
          chainId: BSC_OFT.chainId,
          name: BSC_OFT.name,
          img: bsc,
        },
      }
    }

    if (chainId === BERA_OFT.chainId) {
      // Only allow Bera → zkSync
      return {
        from: {
          chainId: BERA_OFT.chainId,
          name: BERA_OFT.name,
          img: bera,
        },
        to: {
          chainId: ZKSYNC_OFT.chainId,
          name: ZKSYNC_OFT.name,
          img: Zksync,
        },
      }
    }

    // Default for any other chain (including BSC and WLD) - show zkSync → BSC
    // Other chain users need to manually switch to zkSync first
    return {
      from: {
        chainId: ZKSYNC_OFT.chainId,
        name: ZKSYNC_OFT.name,
        img: Zksync,
      },
      to: {
        chainId: BSC_OFT.chainId,
        name: BSC_OFT.name,
        img: bsc,
      },
    }
  }, [chainId])

  const methods = useForm<BrigeForm>({
    defaultValues: {
      active: 0,
      value: '',
      from,
      to,
    },
    mode: 'all',
  })

  return (
    <FormProvider {...methods}>
      <Helmet>
        <title>Holdstation | Bridge</title>
      </Helmet>

      <div
        className={clsx(
          'w-auto lg:w-full max-w-[502px] relative m-4 p-4 lg:p-5 bg-[#0d0d0d] rounded-2xl border border-[#1f1f1f]',
          'flex flex-col gap-4 overflow-hidden lg:my-10'
        )}
      >
        <Header />

        <div className="flex flex-col gap-3">
          <Chain />

          <Balance />
        </div>

        <div className="w-full h-[1px] bg-[#191919]" />

        <EstimateReceive fee={data ?? 0} />

        <Button fee={data ?? 0} />
      </div>

      <ModalAa />
    </FormProvider>
  )
}
